import { render, staticRenderFns } from "./LogsByDriverView.vue?vue&type=template&id=b31a89a0&scoped=true"
import script from "./LogsByDriverView.vue?vue&type=script&lang=js"
export * from "./LogsByDriverView.vue?vue&type=script&lang=js"
import style0 from "./LogsByDriverView.vue?vue&type=style&index=0&id=b31a89a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31a89a0",
  null
  
)

export default component.exports